import { Map } from 'immutable';

export function subscribe(state, action) {
    let items = state.get('items');

    action.ids.forEach((id) => {
        let item = items.get(id) || Map();

        items = items.set(id, item.set('subscribe', true));
    });

    return state.set('items', items);
}

export function unsubscribe(state, action) {
    let items = state.get('items');

    action.ids.forEach((id) => {
        let item = items.get(id) || Map();

        items = items.set(id, item.set('subscribe', false));
    });

    return state.set('items', items);
}
